import { getAutoHeightRowHeight } from "@platform/btx-grid-components";

import { DOUBLE_LINE_ROW_HEIGHT, SINGLE_LINE_ROW_HEIGHT } from "./constants";
import { financialsRowKinds } from "./types";

import type { FinancialsRowKind } from "./types";

// Rows whose cells size to their own content instead of a fixed height: notes
// wrap long free text, per-coverage variance / dollar-savings grow to two
// lines when a carrier's paired value can't fit inline, and an overridden
// premium drops its icons below the value in a narrow column (the data columns
// set `autoHeight`).
const AUTO_HEIGHT_ROW_KINDS: ReadonlySet<string> = new Set([
  financialsRowKinds.ANNUAL_PREMIUM,
  financialsRowKinds.NOTES,
  financialsRowKinds.TOTAL_NOTES,
  financialsRowKinds.VARIANCE,
  financialsRowKinds.DOLLAR_SAVINGS,
]);

const DOUBLE_LINE_ROW_KINDS: ReadonlySet<string> = new Set([
  financialsRowKinds.TOTAL_VARIANCE,
  financialsRowKinds.TOTAL_DOLLAR_SAVINGS,
]);

/**
 * Resolves a row's height from its kind. Returns `undefined` for kinds that
 * should auto-size to their content (wrapped notes); otherwise a fixed height.
 */
export const getFinancialsRowHeight = (
  kind?: FinancialsRowKind,
): number | undefined =>
  getAutoHeightRowHeight(
    !!kind && AUTO_HEIGHT_ROW_KINDS.has(kind),
    kind && DOUBLE_LINE_ROW_KINDS.has(kind)
      ? DOUBLE_LINE_ROW_HEIGHT
      : SINGLE_LINE_ROW_HEIGHT,
  );
